define((require) => {
    'use strict';

    const _ = require('lodash');

    return function keyBy(collection, key) {
        return _.reduce(
            collection,
            (accumulator, item) => {
                if (_.isObject(item) && _.has(item, key)) {
                    const keyValue = item[key];

                    accumulator[keyValue] = item;
                }

                return accumulator;
            },
            {},
        );
    };
});
